<template>
  <section
    v-if="user.objectId"
    class="full-center loading"
    :class="{
      'loading-active': isProgressActive,
      'loading-init-complete': isAppReady,
      'transparent': isTransparent
    }"
  >
    <h1
      v-if="property.objectId || currentBuilding.objectId"
      v-show="isProgressActive && !isAppReady && !isLoadingBarCustom"
      class="progress-preview-title"
    >
      {{ property.name || currentBuilding.nameMulti[lang] || currentBuilding.name }}
    </h1>
    <!--.top-fixed = put the progress bar to top, not in center-->
    <i-progress
      v-show="isProgressActive && !isLoadingBarCustom"
      :class="{ 'top-fixed': isAppReady }"
      :value="progressValue"
      :max="progressMax"
      :color="color"
      :color2="color2"
    />
    <fullscreen-video
      class="video"
      :is-fullscreen="isLoadingBarCustom && !isAppReady"
      :url="videoUrl"
      :controls="false"
      bg-color="#fff"
      :is-muted="true"
      :is-paused="false"
      :loop="true"
    />
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import IProgress from '../IProgress.vue'
import { loadingBarCustomConfig } from '~js/constants'
import FullscreenVideo from '@/components/FullscreenVideo'
export default {
  name: 'LoadingIndex',
  components: {
    IProgress,
    FullscreenVideo
  },
  props: {
    color: {
      type: String,
      default () {
        return ''
      }
    },
    color2: {
      type: String,
      default () {
        return ''
      }
    }
  },
  data () {
    return {
      lang: this.$i18n.locale
    }
  },
  computed: {
    ...mapGetters([
      'currentBuilding',
      'isAppReady',
      'isProgressActive',
      'progressMax',
      'progressValue',
      'property',
      'user'
    ]),
    isLoadingBarCustom () {
      const headquarter = this.user.headquarter
      return headquarter && headquarter.title === loadingBarCustomConfig.headQuarterTitle
    },
    videoUrl () {
      return loadingBarCustomConfig.videoSrc
    },
    isTransparent () {
      return this.$route.query.background === 'transparent'
    }
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

.loading {
  z-index: $loading-z
  &.loading-active {
    background-color: $loading-bgc
    &.transparent {
      background-color: transparent
    }
  }
  &.loading-init-complete {
    background-color: transparent
    pointer-events: none
    transition: .8s background-color ease-out 1s
    &.loading-active {
      background-color: transparent
    }
  }
}
@media screen and (max-width:768px){
  .video {
    width: 900px  !important
  }
}
.progress-preview-title {
  @extend .text-with-gray-bg
  line-height: 25px;
  height: 25px;
  font-size: 18px;
  margin-bottom: 21px;
  text-align: center;
}
</style>
